<template>
    <auth-layout>

        <header-page title="Beranda"/>
        <div class="mrt-top">
         <!--   <a href="https://www.instagram.com/yoursay_id/" target="_blank"><img class="" src="/assets/images/banner-woman.jpg"></a> -->
        </div>
        <div>
            <loading-block v-if="loading" />
            <div v-else>
                <div v-if="events.length > 0">
                    <h3 class="font-weight-bold text-center mb-3">Event & Promo</h3>
                    <div class="promo" v-if="events.length > 0">
                        <small-card-event
                            v-for="item in events"
                            :key="item._id"
                            :image="item.file"
                            :title="item.title"
                            :date="item.startdate"
                            :endDate="item.enddate"
                            author=""
                            view=""
                            :link="item.url"
                        />
                    </div>
                    <div v-else class="text-center">
                        <p>Tidak ada Event & Promo</p>
                    </div>
                </div>
            </div>
        </div>

        <ul class="nav nav-pills mb-3 justify-content-center custom-nav" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
                <a class="nav-link active" id="pills-home-tab" data-toggle="pill" href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">Top Article of the Week</a>
            </li>
            <li class="nav-item" role="presentation">
                <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">Top Writer of the Week</a>
            </li>
        </ul>
        <div class="tab-content" id="pills-tabContent">
            <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                <article-week/>
            </div>
            <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                <writer-week/>
            </div>
        </div>

    </auth-layout>
</template>
<style scoped>
.promo {
    padding: 0 5%;
}
.nav-link {
    padding: 0.5rem 1.2rem;
    font-size: 17px;
}
.custom-nav {
    display: flex;
    flex-wrap: nowrap;
}
.mrt-top{
    margin: 20px 0px;
}
.mrt-top a img{
    width: 100%;
    border-radius: 18px;
    padding: 0px 14px;
}
@media only screen and (max-width: 500px) {
    .custom-nav .nav-link {
        font-size: 14px;
    }
}
</style>
<script>
import axios from "axios";
import ArticleWeek from "../components/ArticleWeek";
import WriterWeek from "../components/WriterWeek";
import SmallCardEvent from "../components/Card/SmallCardEvent";
import Interest from "../../mobile/components/Interest";
import Alertprofile from "../../mobile/components/Alertprofile";
export default {
    components: {
        ArticleWeek,
        WriterWeek,
        SmallCardEvent,
        Interest,
        Alertprofile
    },
    data() {
        return {
            events: [],
            loading: true,
            showEditProfile: false
        }
    },
    mounted() {
        this.getEvent()
    },
    methods: {
        handleShow(status) {
            if(status) {
                // Show edit profile
                this.showEditProfile = true;
            }
        },
        getEvent() {
            const token = this.$cookies.get('token');
            axios.get(`/api/widget/event`, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.events = response.data;
                    this.loading = false;
                })
                .catch((error) => {

                });
        }
    }
}
</script>
